// eslint-disable-next-line no-restricted-imports
import { Collapse as AntCollapse } from 'antd';
import { CollapseProps } from 'antd/es/collapse';
import styled, { css } from 'styled-components';
import { ifNotProp } from 'styled-tools';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

// Ln 22-24 NOTE:: This should be an antd fix
export const Collapse = styled(AntCollapse)<CollapseProps>`
  background: transparent;
  border: 0;

  .ant-collapse-item {
    border-bottom: none;
    background-color: var(--white-100);

    .ant-collapse-header {
      align-items: center;
      background-color: var(--white-100);

      ${ifNotProp(
        'ghost',
        css`
          border-top: 1px solid var(--border-color);
        `,
      )};

      display: flex;
      height: 48px;
      padding: 0 var(--layout-04) 0 0;

      > svg {
        padding: 0px;
        top: 14px;
      }

      &:hover {
        background: var(--hover-color);
        border-color: var(--hover-color);
      }
    }

    &:first-child .ant-collapse-header {
      border-top-color: transparent;
    }

    .ant-collapse-content {
      border-top: 0;
    }

    .ant-collapse-content-box {
      padding: 0;
    }

    &.ant-collapse-item-active {
      padding-bottom: var(--layout-03);
      transition: all var(--animation-duration-slow) ease;
    }

    .ant-collapse-extra {
      visibility: hidden;
      margin: 0 var(--layout-01) 0 auto;
    }

    &.ant-collapse-item-active .ant-collapse-extra {
      visibility: visible;
    }
  }
`;

export const { Panel: BasePanel } = Collapse;
export const Panel = withHideIfNotAllowed(BasePanel);
export { PanelHeaderTitle } from './panel';
